import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

export default function TopHeader({ title, cart, currentUser, onLogout }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  let cartCount = 0;
  if (Array.isArray(cart)) {
    for (let i = 0; i < cart.length; i++) {
      cartCount += Number(cart[i]?.quantity || 0);
    }
  }

  const role = currentUser?.role || "";
  const isSeller = role === "seller" || role === "admin";
  const isBuyer = role === "buyer" || role === "admin";

  // seller -> My Listings, buyer -> Cart, guest -> nothing
  const quickLink = isSeller
    ? { to: "/my-listings", label: "My Listings" }
    : isBuyer
      ? { to: "/cart", label: "Cart" }
      : null;
  // buyer -> My Orders, seller/admin -> Seller Orders
  const ordersLink = currentUser
    ? isSeller
      ? { to: "/seller-orders", label: "Orders" }
      : isBuyer
        ? { to: "/my-orders", label: "My Orders" }
        : null
    : null;

  const navCls = ({ isActive }) => (isActive ? "active" : "");
  const close = () => setOpen(false);

  function logoutNow() {
    if (typeof onLogout === "function") onLogout();
    close();
    navigate("/");
  }

  return (
    <header className="sa-topnav">
      <div className="sa-topnav-inner">
        <button
          className="sa-burger"
          onClick={() => setOpen(true)}
          aria-label="Open menu"
          type="button"
        >
          ☰
        </button>

        <Link
          to="/"
          className="sa-logo"
          onClick={close}
          aria-label="Go to home"
        >
          <img
            className="sa-logoImg"
            src="/images/secondaid_logo.png"
            alt="SecondAid"
          />
        </Link>

        {/* Desktop links */}
        <nav className="sa-links" aria-label="Primary">
          <NavLink to="/" className={navCls}>
            Home
          </NavLink>

          <NavLink to="/categories" className={navCls}>
            Shop
          </NavLink>
          <NavLink to="/requests" className={navCls}>
            Requests
          </NavLink>
          {ordersLink ? (
            <NavLink to={ordersLink.to} className={navCls}>
              {ordersLink.label}
            </NavLink>
          ) : null}

          {quickLink ? (
            <NavLink to={quickLink.to} className={navCls}>
              {quickLink.label}
              {quickLink.to === "/cart" && cartCount > 0 ? (
                <span className="sa-pillCount">{cartCount}</span>
              ) : null}
            </NavLink>
          ) : null}
        </nav>

        {/* Desktop right */}
        <div className="sa-right">
          {currentUser ? (
            <>
              <Link to="/profile" className="sa-userBtn" onClick={close}>
                <div className="sa-userName">
                  {currentUser.name || "Profile"}
                </div>
                <div className="sa-userRole">{role || "user"}</div>
              </Link>

              <button
                className="sa-logoutBtn"
                onClick={logoutNow}
                type="button"
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="sa-cta sa-ctaGhost" onClick={close}>
                Login
              </Link>
              <Link to="/register" className="sa-cta" onClick={close}>
                Register
              </Link>
            </>
          )}
        </div>
      </div>

      {/* Mobile menu */}
      {open ? (
        <div className="sa-mobileOverlay" onClick={close} role="presentation">
          <div className="sa-mobilePanel" onClick={(e) => e.stopPropagation()}>
            <div className="sa-mobileHeader">
              <div className="sa-mobileTitle">{title || "Menu"}</div>
              <button
                type="button"
                className="sa-mobileClose"
                onClick={close}
                aria-label="Close menu"
              >
                ✕
              </button>
            </div>

            <div className="sa-mobileLinks">
              <NavLink to="/" className={navCls} onClick={close}>
                Home
              </NavLink>

              <NavLink to="/categories" className={navCls} onClick={close}>
                Shop
              </NavLink>
              <NavLink to="/requests" className={navCls} onClick={close}>
                Requests
              </NavLink>
              {ordersLink ? (
                <NavLink to={ordersLink.to} className={navCls} onClick={close}>
                  {ordersLink.label}
                </NavLink>
              ) : null}

              {quickLink ? (
                <NavLink to={quickLink.to} className={navCls} onClick={close}>
                  {quickLink.label}
                  {quickLink.to === "/cart" && cartCount > 0 ? (
                    <span className="sa-mobileCount">({cartCount})</span>
                  ) : null}
                </NavLink>
              ) : null}

              <div className="sa-mobileDivider" />

              {currentUser ? (
                <div className="sa-mobileActions">
                  <Link to="/profile" className="sa-mobileUser" onClick={close}>
                    <div className="sa-mobileUserName">
                      {currentUser.name || "Profile"}
                    </div>
                    <div className="sa-mobileUserRole">{role || "user"}</div>
                  </Link>

                  <button
                    className="sa-logoutBtn"
                    type="button"
                    onClick={logoutNow}
                  >
                    Logout
                  </button>
                </div>
              ) : (
                <div className="sa-mobileActions">
                  <Link
                    to="/login"
                    className="sa-cta sa-ctaGhost"
                    onClick={close}
                  >
                    Login
                  </Link>
                  <Link to="/register" className="sa-cta" onClick={close}>
                    Register
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </header>
  );
}
